const getLegacyCards = (root = document) => {
  const cards = [];

  if (root instanceof Element && root.matches('.product-grid__card--legacy-overlay')) cards.push(root);
  cards.push(...root.querySelectorAll?.('.product-grid__card--legacy-overlay') || []);

  return cards;
};

const updateCard = (card, swatch) => {
  card.dataset.productId = swatch.dataset.productId || '';
  card.closest('product-card')?.setAttribute('data-product-id', swatch.dataset.productId || '');
  const hasSubscription = swatch.dataset.usesSellingPlans === 'true';
  card.querySelector('[data-legacy-product-card-details]')?.setAttribute(
    'data-legacy-card-has-subscription',
    String(hasSubscription)
  );

  card.querySelectorAll('[data-legacy-card-title]').forEach((element) => {
    element.textContent = swatch.dataset.title || '';
  });
  card.querySelectorAll('[data-legacy-card-regular-price]').forEach((element) => {
    element.textContent = swatch.dataset.price || '';
    element.classList.toggle('hidden', !hasSubscription);
  });
  card.querySelectorAll('[data-legacy-card-subscription-price]').forEach((element) => {
    element.textContent = hasSubscription ? swatch.dataset.subscriptionPrice || '' : swatch.dataset.price || '';
  });
  card.querySelectorAll('[data-legacy-card-variant-label]').forEach((element) => {
    element.textContent = swatch.dataset.label || '';
  });
  card.querySelectorAll('[data-legacy-card-refill]').forEach((element) => {
    element.classList.toggle('hidden', swatch.dataset.refill !== 'true');
  });

  const productUrl = swatch.dataset.url;
  if (productUrl) {
    card.closest('product-card')?.querySelector('[ref="productCardLink"]')?.setAttribute('href', productUrl);
    card.querySelector('[ref="productTitleLink"]')?.setAttribute('href', productUrl);
  }

  const image = card.querySelector('.card-gallery img');
  if (image && swatch.dataset.image) {
    image.src = swatch.dataset.image;
    image.removeAttribute('srcset');
  }

  const quickAdd = card.querySelector('quick-add-component');
  if (quickAdd) {
    quickAdd.dataset.productId = swatch.dataset.productId || '';
    quickAdd.dataset.productTitle = swatch.dataset.title || '';
    quickAdd.dataset.usesSellingPlans = swatch.dataset.usesSellingPlans || 'false';
  }

  card.querySelectorAll('input[name="id"]').forEach((input) => {
    input.value = swatch.dataset.variantId || '';
  });

  card.querySelectorAll('[data-legacy-card-swatch]').forEach((button) => {
    const selected = button === swatch;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  setPurchaseOption(card, hasSubscription ? 'subscribe' : 'one-time');
};

const setPurchaseOption = (card, option) => {
  const hasSubscription = card.querySelector('[data-legacy-product-card-details]')?.dataset.legacyCardHasSubscription === 'true';
  const selectedOption = hasSubscription && option === 'subscribe' ? 'subscribe' : 'one-time';

  card.querySelectorAll('[data-legacy-card-purchase-option]').forEach((button) => {
    button.classList.toggle('is-selected', button.dataset.legacyCardPurchaseOption === selectedOption);
  });
  card.querySelectorAll('[data-legacy-card-regular-price]').forEach((element) => {
    element.classList.toggle('hidden', selectedOption !== 'subscribe');
  });
  card.querySelectorAll('[data-legacy-card-subscription-price]').forEach((element) => {
    element.textContent = selectedOption === 'subscribe'
      ? card.querySelector('[data-legacy-card-swatch].is-selected')?.dataset.subscriptionPrice || element.textContent
      : card.querySelector('[data-legacy-card-swatch].is-selected')?.dataset.price || element.textContent;
  });
};

const initialiseLegacyCards = (root = document) => {
  for (const card of getLegacyCards(root)) {
    if (card.dataset.legacyProductCardReady === 'true') continue;
    card.dataset.legacyProductCardReady = 'true';

    card.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const swatch = target.closest('[data-legacy-card-swatch]');
      if (swatch instanceof HTMLElement) {
        event.preventDefault();
        event.stopPropagation();
        updateCard(card, swatch);
        return;
      }

      const formatSwatch = target.closest('[data-legacy-card-format-swatch]');
      if (formatSwatch instanceof HTMLElement) {
        event.preventDefault();
        event.stopPropagation();
        card.querySelectorAll('input[name="id"]').forEach((input) => {
          input.value = formatSwatch.dataset.variantId || '';
        });
        card.querySelectorAll('[data-legacy-card-regular-price], [data-legacy-card-subscription-price]').forEach((element) => {
          element.textContent = formatSwatch.dataset.price || '';
        });
        const image = card.querySelector('.card-gallery img');
        if (image && formatSwatch.dataset.image) {
          image.src = formatSwatch.dataset.image;
          image.removeAttribute('srcset');
        }
        card.querySelectorAll('[data-legacy-card-format-swatch]').forEach((button) => {
          const selected = button === formatSwatch;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        return;
      }

      const quickAddButton = target.closest('[data-legacy-card-quick-add]');
      if (quickAddButton instanceof HTMLElement) {
        event.preventDefault();
        event.stopPropagation();
        const quickAdd = card.querySelector('quick-add-component .quick-add__button');
        if (quickAdd instanceof HTMLElement) {
          quickAdd.click();
        } else {
          // Legacy overlay cards use the same add-to-cart form rendered by the
          // normal Horizon buy-buttons block. Submit that form when no modal
          // quick-add component is present.
          const addToCartForm = card.querySelector('form[data-type="add-to-cart-form"]');
          if (addToCartForm instanceof HTMLFormElement) addToCartForm.requestSubmit();
        }
        return;
      }

      const purchaseOption = target.closest('[data-legacy-card-purchase-option]');
      if (purchaseOption instanceof HTMLElement) {
        event.preventDefault();
        event.stopPropagation();
        setPurchaseOption(card, purchaseOption.dataset.legacyCardPurchaseOption || 'one-time');
        return;
      }

      const previous = target.closest('[data-legacy-card-swatch-previous]');
      const next = target.closest('[data-legacy-card-swatch-next]');
      if (previous || next) {
        event.preventDefault();
        event.stopPropagation();
        const swatches = card.querySelector('[data-legacy-card-swatches]');
        swatches?.scrollBy({ left: previous ? -96 : 96, behavior: 'smooth' });
      }
    });
  }
};

initialiseLegacyCards();
document.addEventListener('shopify:section:load', (event) => initialiseLegacyCards(event.target));
